export enum TypeOrderStatus {
  NONE = "",
  PENDING = "Pendente",
  APPROVED = "Aprovado",
  RECEIVED = "Recebido",
  WAITING_PAYMENT = "Aguardando Pagamento",
  WAITING_CLIENT_AUTHORIZATION = "Aguardando Autorização",
  OPENED = "Aberto",
  REJECTED = "Rejeitado",
  CANCELED = "Cancelado",
  DELIVERED = "Entregue",
  IN_TRANSIT = "Em Trânsito",
  RETURNED = "Devolvido",
  EXPIRED = "Expirado",
  COMPLETED = "Completo",
  IN_PROGRESS = "Em Progresso",
  ON_HOLD = "Em Espera",
  DELIVERED_TO_SENDER = "Entregue ao Remetente",
  DELIVERED_TO_RECEIVER = "Entregue ao Destinatário",
  DELIVERED_TO_SENDER_AND_RECEIVER = "Entregue a Ambos",
  DELIVERED_TO_SENDER_AND_RECEIVER_AND_RETURNED = "Entregue e Devolvido"
}

export enum TypeWorkOrderPdf {
  WORK_ORDER = "WORK_ORDER",
  WORK_ORDER_DETAILS = "WORK_ORDER_DETAILS"
}
